module.exports = __webpack_public_path__ + "img/trash-can-xmark.ac14d709.svg";